import { HttpClient } from '@angular/common/http';
import { Base } from '../base';

export class Ohlcs extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/ohlcs`);
  }

  query(params?: any) {
    return this.api.query(params);
  }
}
